import React, {Component} from 'react';
import DispatchListItem from './dispatch-item';
import time from '../../../script/utils/time';
import store from '../../../script/store';
import {ApplicationActions} from '../../../data/Action';
import './dispatch-list.css';


let counter = 0;

export default class DispatchList extends Component {
    /*
    isOrderSelected(order) {
        return this.props.orderSelected && this.props.orderSelected.id === order.id;
    }*/

    render() {


        const scheduledData = (this.props.data ? this.props.data : []);

        const totalOrders = scheduledData.length;

        const appState = this.props.appState.scheduled;


        return (
            <div className="orders-list-wrapper">
                <div className="orders-list-header">
                    <span>Agendamentos</span>
                    <span className="orders-list-header-count">{totalOrders}</span>
                </div>
                <div className="dispatch-list">
                    {scheduledData.map(scheduledOrder => (
                        <DispatchListItem
                            key={scheduledOrder.id}
                            data={scheduledOrder}
                            onClickAction={this.onClickFastForward.bind(this)}
                            appState={appState}
                        />
                    ))}
                </div>
            </div>
        );
    }


    onClickFastForward(scheduledOrder, event){
        console.log("Fast Forward for order: " + scheduledOrder.id);
        ApplicationActions.onClickScheduledFastForward(scheduledOrder);
        // store.fastForwardScheduledOrder(orderId);
    }

}



// WEBPACK FOOTER //
// ./src/app/Sidebar/dispatch-list/index.js